import PropTypes from 'prop-types'
import cn from 'classnames'

import s from './TextArea.module.scss'

const TextArea = ({ input, placeholder, meta: { touched, error, submitError }, errorMessage, label, labelClassName, textAreaClassName, maxLength }) => {
  // Check for both validation errors and submit errors (from stopSubmit)
  const isResError = typeof error === 'string'
  const hasError = touched && error
  const isError = hasError || submitError
  const errorId = `error-${input.name}`
  const labelId = `label-${input.name}`

  // Determine display message: string errors from API take priority, then errorMessage prop
  const displayError = isResError ? error : (submitError || errorMessage)

  return (
    <>
      {label && (
        <label htmlFor={input.name} className={cn(s.label, labelClassName, isError && s.errorLabel)} id={labelId}>
          {label}
        </label>
      )}
      <textarea
        {...input}
        id={input.name}
        type='text'
        maxLength={maxLength || 1500}
        className={cn(s.input, textAreaClassName, isError && s.errorInput)}
        placeholder={placeholder}
        aria-labelledby={label ? labelId : undefined}
        aria-invalid={isError ? 'true' : 'false'}
        aria-describedby={isError ? errorId : undefined}
      />
      {isError && <span className={s.error} id={errorId} role="alert">{displayError}</span>}
    </>
  )
}

TextArea.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func
  }),
  placeholder: PropTypes.string
}

TextArea.defaultProps = {
  input: {
    value: '',
    onChange: null
  },
  placeholder: 'Type a description here'
}

export { TextArea }
